import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

const CartableTag: React.FunctionComponent<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="hang-tag-line-24">
                    <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                    <path
                        d="M2.4,11.6 L11.3,2.7 C11.7,2.3 12.3,2.1 12.9,2.1 L19.4,2.8 C20.3,2.9 21.1,3.6 21.2,4.6 L21.9,11.1 C22,11.7 21.8,12.3 21.3,12.7 L12.4,21.6 C11.6,22.4 10.4,22.4 9.6,21.6 L2.4,14.4 C1.6,13.6 1.6,12.4 2.4,11.6 Z"
                        id="Path"
                        stroke="#585858"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    ></path>
                    <circle id="Oval" fill="#585858" fillRule="nonzero" cx="16.5" cy="7.5" r="1.5"></circle>
                </g>
            </g>
        </SvgIcon>
    );
};

export { CartableTag };
